@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';

.filter-container {
  padding: @space-16;
  width: 100%;
  border: solid 1px var(--default--border-color--12);
  border-radius: 8px;
  margin-bottom: @space-16;
  background-color: @white;

  .items-wrapper {
    display: flex;
    flex-flow: row wrap;
    gap: @space-16;
    width: 100%;
  }

  .label {
    display: block;
    margin-bottom: @space-8;
    font-weight: 500;
  }

  .warehouse-value {
    display: flex;
    align-items: center;
    min-height: 36px;
    .truncate();
  }

  .checkbox-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: @space-8;
  }

  .buttons-container {
    display: flex;
    flex-direction: row;
    gap: @space-8;
    margin-left: 0;
    align-items: flex-start;
    padding-top: @space-8;
    padding-bottom: @space-8;
  }
}
